import { dataFieldToColumnType } from '@import/functions/model-transformations/data-field-to-column-type.function';
import { MappingTableSection } from '@import/interfaces';
import { MappingTableTypes } from '@import/types/mapping-table.types';
import { MappingTables } from '@import/types/mapping-tables.types';
import { DataField } from '@models/settings/data-field.model';
import { ColumnType } from '@import/interfaces';

const shouldUpdateMappingSections = (section: MappingTableSection) => {
    return Object.keys(section).length > 0;
};

const shouldInitializeCustomFieldSections = (section: MappingTableSection) => {
    return section === null;
};

/*
 * This method will remove any duplicate fields and return an array of only new fields
 * that should be added to the mapping table
 */
const getNewFieldsToAdd = (sectionFields: ColumnType[], newFields: ColumnType[]): ColumnType[] => {
    const fieldLabels = sectionFields.map((field) => field.label);
    return newFields.filter((field) => !fieldLabels.includes(field.label));
};

/*
 * This method is responsible for creating the data structure needed for inserting
 * Custom Fields/DataField[] into the MappingTables
 */
export const addDataFieldsToMappingTables = (
    dataFields: DataField[],
    mappingTables: MappingTables,
    type: MappingTableTypes
): void => {
    const sectionFields: MappingTableSection = dataFields.reduce((sections: MappingTableSection, field: DataField) => {
        if (!sections[field.dataFieldGroup.name]) {
            sections[field.dataFieldGroup.name] = [];
        }
        sections[field.dataFieldGroup.name].push(dataFieldToColumnType(field));
        return sections;
    }, {});

    if (!shouldUpdateMappingSections(sectionFields)) {
        return;
    }

    if (shouldInitializeCustomFieldSections(mappingTables[type].sections)) {
        mappingTables[type].sections = sectionFields;
        return;
    }

    /*
     * Add the fields to the mapping table if it has already been initialized
     */
    for (const field of Object.keys(sectionFields)) {
        mappingTables[type].sections[field] = mappingTables[type].sections[field]
            ? [
                  ...mappingTables[type].sections[field],
                  ...getNewFieldsToAdd(mappingTables[type].sections[field], sectionFields[field]),
              ]
            : sectionFields[field];
    }
};
